import React, { FC } from 'react'

const ProductViewSkeleton: FC = () => {
  return (
    <React.Fragment>
        <nav className={`tw-flex`} aria-label="Breadcrumb">
            <ol className={`tw-inline-flex tw-items-center tw-space-x-1 md:tw-space-x-3 tw-animate-pulse`}>
                <li className={`tw-inline-flex tw-items-center`}>
                    <div className={`tw-flex tw-items-center`}>
                        <div className={`tw-flex tw-space-x-16 tw-w-16`}>
                            <div className={`tw-flex-1 tw-space-y-2 tw-w-4`}>
                                <div className={`tw-h-1.5 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
                            </div>
                        </div>
                    </div>
                </li>
                <li className={`tw-inline-flex tw-items-center`}>
                    <div className={`tw-flex tw-items-center`}>
                        <div className={`tw-flex tw-space-x-16 tw-w-2`}>
                            <div className={`tw-flex-1 tw-space-y-2 tw-w-2`}>
                                <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
                            </div>
                        </div>
                        <div className={`tw-flex tw-space-x-16 tw-w-16 tw-ml-5`}>
                            <div className={`tw-flex-1 tw-space-y-2 tw-w-4`}>
                                <div className={`tw-h-1.5 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
                            </div>
                        </div>
                    </div>
                </li>
                <li className={`tw-inline-flex tw-items-center`}>
                    <div className={`tw-flex tw-items-center`}>
                        <div className={`tw-flex tw-space-x-16 tw-w-2`}>
                            <div className={`tw-flex-1 tw-space-y-2 tw-w-2`}>
                                <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
                            </div>
                        </div>
                        <div className={`tw-flex tw-space-x-16 tw-w-32 tw-ml-5`}>
                            <div className={`tw-flex-1 tw-space-y-2 tw-w-4`}>
                                <div className={`tw-h-1.5 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
                            </div>
                        </div>
                    </div>
                </li>          
            </ol>
        </nav>
        <div className={`tw-flex tw-justify-between tw-items-center tw-animate-pulse`}>
            <div className={`tw-mt-3 tw-flex`}>
                <div className={`tw-flex tw-items-center tw-gap-2`}>
                    <div className={`tw-flex tw-space-x-16 tw-w-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-2`}>
                            <div className={`tw-h-6 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
                        </div>
                    </div> 
                    <div className={`tw-flex tw-space-x-16 tw-w-64`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-64`}>
                            <div className={`tw-h-6 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
                        </div>
                    </div>       
                    <div className={`tw-flex tw-space-x-16 tw-w-16`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-10`}>
                            <div className={`tw-h-6 tw-bg-greyishBlue tw-rounded-xl tw-col-span-5`} />
                        </div>
                    </div>        
                </div>         
            </div>
            <div className={`tw-mt-3 tw-flex tw-pr-2`}>
                <div className={`tw-flex tw-items-center tw-gap-2`}> 
                    {/* <div className={`tw-flex tw-space-x-16 tw-w-64`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-64`}>
                            <div className={`tw-h-10 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
                        </div>
                    </div>        */}
                    <div className={`tw-flex tw-space-x-16 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-10`}>
                            <div className={`tw-h-10 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-10`}>
                            <div className={`tw-h-10 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    {/* <div className={`tw-flex tw-space-x-16 tw-w-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-2`}>
                            <div className={`tw-h-10 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>         */}
                </div>         
            </div>    
        </div>
        <div className={`tw-flex tw-space-x-16 tw-w-auto tw-mt-2`}>
            <div className={`tw-flex-1 tw-space-y-2 tw-w-auto`}>
                <div className={`tw-h-0.5 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
            </div>                
        </div>

        <div className={`tw-rounded tw-my-3 tw-flex tw-flex-grow tw-flex-wrap tw-box-border tw-border-[1px] tw-border-solid tw-border-[#E2E3E4]`}>
            <div className={`tw-w-[16%] tw-p-2 tw-animate-pulse`}>
                <div className={`tw-rounded tw-pt-1 tw-ps-1 tw-pe-2 tw-w-[196px] tw-h-[196px] tw-bg-[#F7F7F7] tw-flex-shrink-0 tw-border-[#F2F2F2]`}>    
                    <div className={`tw-flex tw-space-x-16`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-10`}>
                            <div className={`tw-w-[190px] tw-h-[190px] tw-bg-greyishBlue tw-rounded-xl tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-w-48 tw-overflow-x-auto`}>
                        {[50, 51, 52, 53].map((index) => (
                            <div key={index} className={`tw-rounded tw-mt-1 tw-w-[35px] tw-h-[35px] tw-bg-[#F7F7F7] tw-flex-shrink-0 tw-border-[#F2F2F2] tw-mx-0.5`}>
                                <div className={`tw-flex tw-space-x-16 tw-w-[35px] tw-h-[35px]`}>
                                    <div className={`tw-flex-1 tw-space-y-2 tw-w-10`}>
                                        <div className={`tw-h-[35px] tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={`tw-w-[82%] tw-flex-wrap tw-mt-3 tw-ms-4 `}>
                    <div className={`tw-flex tw-space-x-16 tw-w-1/2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-5 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-mt-2 tw-w-3/4`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-3 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-mt-2 tw-w-1/3`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
            
                    <div className={`tw-flex tw-space-x-16 tw-mt-2 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-mt-4 tw-ms-1 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-4 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
          <div className={`tw-flex tw-flex-wrap tw-justify-start`}>
            {[99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114].map((index) => {
              return(
              <div key={index } className={`tw-w-1/3 tw-p-1 tw-mt-3`}>
                <div className={`tw-flex tw-space-x-16 tw-w-32`}>
                    <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                        <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                    </div>
                </div>
                        <div className={`tw-flex tw-space-x-16 tw-mt-2 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
              </div>
            )})}
          </div>

          <div className={`tw-flex tw-space-x-16 tw-w-32 tw-mt-4 tw-ms-1`}>
            <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                <div className={`tw-h-4 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
            </div>            
          </div>
          <div className={`tw-flex tw-flex-wrap tw-justify-start tw-py-2`}>
            <div className={`tw-w-1/3 tw-p-1`}>
                    <div className={`tw-flex tw-space-x-16 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-w-32 tw-mt-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
            </div>

            <div className={`tw-w-1/3 tw-p-1`}>
            <div className={`tw-flex tw-space-x-16 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-w-32 tw-mt-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
            </div>

            <div className={`tw-w-1/3 tw-p-1`}>
            <div className={`tw-flex tw-space-x-16 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-w-32 tw-mt-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
            </div>

            <div className={`tw-w-1/3 tw-p-1 tw-mt-2`}>
            <div className={`tw-flex tw-space-x-16 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-w-32 tw-mt-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
            </div>

            <div className={`tw-w-1/3 tw-p-1 tw-mt-2`}>
            <div className={`tw-flex tw-space-x-16 tw-w-32`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-w-32 tw-mt-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
            </div>
          </div>
        </div>
        </div>      

        <div className={`tw-justify-between tw-flex tw-text-center tw-items-center tw-gap-2 tw-rounded tw-bg-white tw-box-border tw-w-auto tw-h-12 tw-border-[1px] tw-border-solid tw-border-gainsboro-200 tw-p-2.5`}>
            <div className={`tw-flex tw-items-center tw-gap-2`}>
            <div className={`tw-flex tw-space-x-16 tw-w-32 tw-mt-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
                    <div className={`tw-flex tw-space-x-16 tw-w-2 tw-mt-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
            </div>
            <div className={`tw-flex tw-space-x-16 tw-w-4 tw-mt-2`}>
                        <div className={`tw-flex-1 tw-space-y-2 tw-w-24`}>
                            <div className={`tw-h-4 tw-bg-greyishBlue tw-rounded tw-col-span-5`} />
                        </div>
                    </div>
        </div>      
        
        
    </React.Fragment>
    
  )
}

export default ProductViewSkeleton